import React from 'react'

import { useLanguageRedirectPortal } from '@/entities/language'
import { getAssetUrl } from '@/shared/lib/cdn'
import { useI18n } from '@/shared/lib/i18n'
import { KoreanAgeRatingBadge } from '@/shared/ui/korean-age-rating-badge'
import { HomePageAuthForm } from '@/widgets/auth-form'
import { Footer } from '@/widgets/layout/footer'
import { NavbarHome } from '@/widgets/layout/navbar'
import { PageHead } from '@/widgets/layout/seo'

import { homePageRecipe, imageCharacterClassName } from './recipe'
import { useSafariWebPCompatibility } from './use-safari-webp-compatibility'

export function HomePage() {
    useLanguageRedirectPortal()

    const { lang } = useI18n()
    const styles = homePageRecipe()

    return (
        <React.Fragment>
            <PageHead path="/" />

            <div className={styles.pageContainer}>
                <NavbarHome />

                <KoreanAgeRatingBadge />

                <div className={styles.landingBackgroundContainer}>
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        poster={getAssetUrl('/assets/portalHeroLoad.jpg')}
                        className={styles.taongaBackgroundVideo}
                    >
                        <source src={getAssetUrl('/assets/index_background.webm')} type="video/webm" />
                        <source src={getAssetUrl('/assets/index_background.mp4')} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>

                    <IndexCharacter />

                    <picture>
                        <source srcSet={getAssetUrl('/assets/index_left.webp')} type="image/webp" />
                        <source srcSet={getAssetUrl('/assets/index_left.png')} type="image/png" />
                        <img
                            alt="palm tree"
                            src={getAssetUrl('/assets/index_left.png')}
                            draggable="false"
                            className={styles.imageLeft}
                        />
                    </picture>

                    <picture>
                        <source srcSet={getAssetUrl('/assets/index_bottom_right.webp')} type="image/webp" />
                        <source srcSet={getAssetUrl('/assets/index_bottom_right.png')} type="image/png" />
                        <img
                            alt="bush"
                            src={getAssetUrl('/assets/index_bottom_right.png')}
                            draggable="false"
                            className={styles.imageBottomRight}
                        />
                    </picture>
                </div>

                <div className={styles.pageContent}>
                    <img
                        src={getAssetUrl(`/assets/img/${lang}/taongaLogo.png`)}
                        alt="Taonga Logo"
                        draggable="false"
                        className={styles.landingLogo}
                    />
                    <div className={styles.authFormContainer}>
                        <HomePageAuthForm />
                    </div>
                </div>

                <Footer />
            </div>
        </React.Fragment>
    )
}

function IndexCharacter() {
    // NOTE: although Safari 14-15 supports webp, it has a bug that causes the animated image to be displayed incorrectly
    const isWebpSupported = useSafariWebPCompatibility()

    if (!isWebpSupported) {
        return (
            <img
                alt="character"
                src={getAssetUrl('/assets/index_character.png')}
                draggable="false"
                className={imageCharacterClassName}
            />
        )
    }

    return (
        <picture>
            <source srcSet={getAssetUrl('/assets/index_character.webp')} type="image/webp" />
            <source srcSet={getAssetUrl('/assets/index_character.png')} type="image/png" />
            <img
                alt="character"
                src={getAssetUrl('/assets/index_character.png')}
                draggable="false"
                className={imageCharacterClassName}
            />
        </picture>
    )
}
